'use client';

import React from 'react';
import { ErrorBoundary } from '@benzinga/core-ui';

interface VideoArticlePlayerProps {
  className?: string;
  priority?: boolean;
  title?: string;
  youtubeId: string | null;
}

export const VideoArticlePlayer: React.FC<VideoArticlePlayerProps> = ({
  className,
  priority = false,
  title = 'Benzinga video',
  youtubeId,
}) => {
  if (!youtubeId) {
    return null;
  }

  return (
    <ErrorBoundary name="video-article-player">
      <div
        className={`video-article-player relative aspect-video w-full overflow-hidden rounded-md bg-[#0f1a2a] outline outline-1 outline-white/10 ${className ?? 'mb-4'}`}
      >
        <iframe
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 h-full w-full border-0"
          loading={priority ? 'eager' : 'lazy'}
          src={`https://www.youtube.com/embed/${youtubeId}`}
          title={title}
        />
      </div>
    </ErrorBoundary>
  );
};
